module.exports = __webpack_public_path__ + "media/images/flags/32/Germany-b36fe795c69d3c48dc8c928b4597546e.png";